module.exports = __webpack_public_path__ + "ee65597fb02c09bdb93f67f4a9f828a4.svg";